export enum RidesharingAppEnum {
    Initial = 255,
    None = 0,
    Angkas = 1,
    Moveit = 2,
    Joyride = 3,
    Grab = 4,
    Uber = 5,
    GrabExpress = 6,
    Lalamove = 7,
    HappyMove = 8,
    Transportify = 9,
    Others = 10,
    FoodPanda = 11,
    PickARoo = 12,
    DingDong = 13,
    Maxim = 14
}
